import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "img1 h-auto" }, null, -1)
const _hoisted_2 = {
  class: "fixed-alerts",
  "aria-label": "Avisos importantes"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Informamos que não haverá expediente no dia 04 de novembro. Dessa forma, as notas de comissão encaminhadas no dia 03 de novembro terão seus pagamentos realizados excepcionalmente no dia 06 de novembro. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "alert-paragraph" }, " Agradecemos a compreensão e a parceria de todos. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Devido ao processo de fechamento, o envio de notas fiscais (NFs) para recebimento de comissões deve acontecer até o dia 27 de cada mês. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "alert-paragraph" }, " Caso haja alguma alteração nos dados bancários da sua empresa, informe através do formulário de dúvidas, seguindo o passo a passo do tópico 4 do FAQ. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Atenção às regras para envio de notas fiscais (NFs): ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Para bases PRIME INTERWAY (MG, PR e SC), o limite é de até 20 recebimentos por NF."),
  /*#__PURE__*/_createElementVNode("li", null, "Para bases RBCODE (RJ e SP), o limite permanece em até 80 recebimentos por NF."),
  /*#__PURE__*/_createElementVNode("li", null, "Será aceita uma nota por dia.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "alert-paragraph" }, " O prazo para resgate de comissões disponíveis é de 2 anos a contar da disponibilidade. Após esse prazo, as comissões não resgatadas expiram e não poderão ser recuperadas. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " A nota fiscal deve ser emitida dentro do mesmo mês de criação do Pedido de Compra. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "alert-paragraph" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Não serão aceitas"),
  /*#__PURE__*/_createTextVNode(" notas fiscais emitidas em mês diferente do mês de criação do Pedido de Compra. ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Para bases PRIME INTERWAY (MG, PR e SC), o limite de adição de NFs liberadas será de até 20 recebimentos por NF; "),
  /*#__PURE__*/_createElementVNode("li", null, " Para bases RBCODE (RJ e SP), o limite de adição de NFs liberadas permanece em até 80 recebimentos por NF; "),
  /*#__PURE__*/_createElementVNode("li", null, "E será aceita uma nota por dia.")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useHead } from "@vueuse/head"
import { HomeContainer } from "@/components/atoms"
import Loading from "@/components/molecules/Loading.vue"
import { getPayload } from "../repositories/login"
import { onMounted } from "vue"
import { SAVE_USER_REV } from "../store/mutationsTypes"
import { getUserById } from "../repositories/users"
import { ref } from "vue"
import { useStore } from "../store"

import Home from "../components/organisms/Home.vue"
import { useClient } from "@/clients/AxiosClient"
import { setSendPermission } from "@/utils/permissions"
import { Routes } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'Homepage',
  setup(__props) {

const store = useStore()

let showLoading = ref(false)

useHead({ title: "Comissão Revenda - Home" })

onMounted(async () => {
	try {
		showLoading.value = true

		const payload = await getPayload()

		const userInfo: any = await getUserById(payload.data.data.payload.id)

		const data = {
			username: userInfo.username,
			codRev: userInfo.codRev,
			aidc: userInfo.aidc,
			rbcode: userInfo.rbcode,
			name: userInfo.user.name,
			email: userInfo.user.email,
			id: userInfo.user.id,
		}

		store.commit(SAVE_USER_REV, data)

		await getSendingPermission(data.codRev)
	} catch (error) {
		console.error("Erro durante inicialização:", error)
	} finally {
		showLoading.value = false
	}
})

const showNotification = ref(true)
const showBankNotification = ref(true)
const showMaintenanceNotification = ref(true)
const showExpiratonDateNotification = ref(true)
const showInvoicePeriodNotification = ref(true)
const holidayNoticeDeadline = new Date(2026, 10, 6, 23, 59, 59, 999)
const showHolidayNotice = ref(new Date() <= holidayNoticeDeadline)

async function getSendingPermission(codRev: string) {
	const resValidation: any = await useClient().get(
		Routes.GET_SEND_PERMISSION + `?codRevSQL=${codRev}`
	)
	setSendPermission(resValidation.data.message.result)
}

const alertTimeout = () => {
	setTimeout(() => {
		showNotification.value = false
	}, 10000)
}

if (showHolidayNotice.value) {
	setTimeout(() => {
		showHolidayNotice.value = false
	}, Math.max(0, holidayNoticeDeadline.getTime() - Date.now() + 1))
}

const removeHolidayNotice = () => {
	showHolidayNotice.value = false
}

const removeNotification = () => {
	showBankNotification.value = false
	showNotification.value = false
}

const removeNotification2 = () => {
	showMaintenanceNotification.value = false
	showExpiratonDateNotification.value = false
}

const removeNotification4 = () => {
	showInvoicePeriodNotification.value = false
}

const removeNotification3 = () => {
	showExpiratonDateNotification.value = false
}

alertTimeout()

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showLoading))
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(HomeContainer), null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(Home, {
          onEnableLoading: _cache[0] || (_cache[0] = (value) => _isRef(showLoading) //@ts-ignore
 ? showLoading.value = value : showLoading = value)
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_v_alert, {
        class: "notificationBox",
        transition: "slide-x-transition",
        color: "info",
        icon: "$info",
        title: "Prezadas Revendas"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", { class: "buttonContent" }, [
            _createElementVNode("button", {
              class: "button",
              onClick: removeHolidayNotice
            }, "Entendi")
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, showHolidayNotice.value]
      ]),
      _withDirectives(_createVNode(_component_v_alert, {
        class: "notificationBox",
        transition: "slide-x-transition",
        color: "warning",
        icon: "$warning",
        title: "Prezadas Revendas"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", { class: "buttonContent" }, [
            _createElementVNode("button", {
              class: "button",
              onClick: removeNotification
            }, "Entendi")
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, showNotification.value || showBankNotification.value]
      ]),
      _withDirectives(_createVNode(_component_v_alert, {
        class: "notificationBox",
        transition: "slide-x-transition",
        color: "info",
        icon: "$info",
        title: "Prezadas Revendas"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", { class: "buttonContent" }, [
            _createElementVNode("button", {
              class: "button",
              onClick: removeNotification2
            }, "Entendi")
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, showMaintenanceNotification.value || showExpiratonDateNotification.value]
      ]),
      _withDirectives(_createVNode(_component_v_alert, {
        class: "notificationBox",
        transition: "slide-x-transition",
        color: "info",
        icon: "$info",
        title: "Prezadas Revendas"
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", { class: "buttonContent" }, [
            _createElementVNode("button", {
              class: "button",
              onClick: removeNotification4
            }, "Entendi")
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, showInvoicePeriodNotification.value]
      ]),
      false
        ? _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            class: "notificationBox",
            transition: "slide-x-transition",
            color: "warning",
            icon: "$warning",
            title: "Prezadas Revendas",
            text: "Devido ao processo de fechamento, o envio de NFs para recebimento de comissões deve acontecer até o dia 27 do mês.\n\t\t\t"
          }, null, 512)), [
            [_vShow, showNotification.value]
          ])
        : _createCommentVNode("", true),
      false
        ? _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            class: "notificationBox",
            transition: "slide-x-transition",
            color: "warning",
            icon: "$warning",
            title: "Prezadas Revendas",
            text: "Agradecemos pela sua atenção e colaboração. Caso haja alguma alteração nos dados bancários da sua empresa, solicitamos que nos informe através do formulário de dúvidas. Siga o passo a passo demonstrado no tópico 4 do FAQ, que foi cuidadosamente elaborado para guiar você durante esse processo."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", { class: "buttonContent" }, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: removeNotification
                }, "Entendi")
              ])
            ]),
            _: 1
          }, 512)), [
            [_vShow, showBankNotification.value]
          ])
        : _createCommentVNode("", true),
      false
        ? _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
            key: 2,
            class: "notificationBox",
            transition: "slide-x-transition",
            color: "info",
            icon: "$info",
            title: "Prezadas Revendas"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Atenção para a nova otimização de envio de notas fiscais (NFs): "),
              _hoisted_12,
              _createElementVNode("div", { class: "buttonContent" }, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: removeNotification2
                }, "Entendi")
              ])
            ]),
            _: 1
          }, 512)), [
            [_vShow, showMaintenanceNotification.value]
          ])
        : _createCommentVNode("", true),
      false
        ? _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
            key: 3,
            class: "notificationBox",
            transition: "slide-x-transition",
            color: "info",
            icon: "$info",
            title: "Prezadas Revendas"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Informamos que o prazo para resgate de comissões disponíveis é de 02 anos a contar da disponibilidade. "),
              _hoisted_13,
              _createTextVNode(" Após essa data, as comissões não resgatadas expiram e não poderão ser mais recuperadas. "),
              _createElementVNode("div", { class: "buttonContent" }, [
                _createElementVNode("button", {
                  class: "button",
                  onClick: removeNotification3
                }, "Entendi")
              ])
            ]),
            _: 1
          }, 512)), [
            [_vShow, showExpiratonDateNotification.value]
          ])
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})